import React from 'react';

const ReferColleagueIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 21"
    fill="currentColor"
    width="1.4em"
    height="1em"
    aria-hidden="true"
  >
    <circle cx="5.5" cy="5" r="4.5" />
    <path d="M0,21 Q5.5,10 11,21 Z" />

    <path
      d="M13,8 L17,11 L13,14"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <circle cx="24.5" cy="5" r="4.5" />
    <path d="M19,21 Q24.5,10 30,21 Z" />
  </svg>
);

export default ReferColleagueIcon;
